import React from "react";
import { connect } from "react-redux";
import { PUBLIC_DIR } from "../config";
import { incCart, decCart, updateCartQuantity } from "../store/actions/cart";
import "./OrderSummaryWidget.css";

class OrderSummaryWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: true, // Mobilde başlangıçta kapalı
      isMobile: window.innerWidth < 1025,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth < 1025;
    this.setState({ isMobile });
  };

  toggleCollapse = () => {
    if (this.state.isMobile) {
      this.setState({ isCollapsed: !this.state.isCollapsed });
    }
  };

  calculatePrices = () => {
    const { cart, settings, customer } = this.props;
    const cartItems = cart && cart.items ? cart.items : [];

    // Sepet toplam fiyatı (indirim öncesi)
    let cartTotalPrice = 0;
    cartItems.forEach((item) => {
      const price = item.sale_price || item.price;
      cartTotalPrice += price * item.quantity;
    });

    // Kategori indirimleri
    let categoryDiscount = 0;
    cartItems.forEach((item) => {
      const price = item.sale_price || item.price;
      const discount = item.discount || 0;
      const discountType = item.discountType || "percentage";

      if (discountType === "percentage") {
        categoryDiscount += (price * item.quantity * discount) / 100;
      } else {
        categoryDiscount += discount * item.quantity;
      }
    });

    const cartAfterCategoryDiscount = cartTotalPrice - categoryDiscount;

    // Premium müşteri indirimi
    let customerDiscount = 0;
    if (customer && customer.discount_enabled) {
      const minCartAmount = customer.min_cart_amount || 0;
      if (cartAfterCategoryDiscount >= minCartAmount) {
        if (customer.discount_type === "percentage") {
          customerDiscount =
            (cartAfterCategoryDiscount * customer.discount_value) / 100;
        } else {
          customerDiscount = customer.discount_value;
        }
      }
    }

    const finalCartPrice = cartAfterCategoryDiscount - customerDiscount;

    // Kargo ücreti
    const freeShippingThreshold =
      settings && settings.free_shipping ? settings.free_shipping : 0;
    const shippingCost =
      settings &&
      settings.shipping_cost &&
      finalCartPrice < freeShippingThreshold
        ? settings.shipping_cost
        : 0;

    const totalPrice = finalCartPrice + shippingCost;

    return {
      cartTotalPrice,
      categoryDiscount,
      customerDiscount,
      shippingCost,
      totalPrice,
      freeShippingThreshold,
    };
  };

  render() {
    const { cart } = this.props;
    const { isCollapsed, isMobile } = this.state;
    const prices = this.calculatePrices();
    const cartItems = cart && cart.items ? cart.items : [];

    const showContent = !isMobile || !isCollapsed;

    return (
      <div style={styles.container} className="order-summary-widget-container">
        {/* Header - Sipariş Özeti ve Ürün Sayısı */}
        <div
          style={styles.header}
          onClick={this.toggleCollapse}
          className="order-summary-header"
        >
          <div style={styles.headerLeft}>
            <h3 style={styles.title}>Sipariş Özeti</h3>
            <span style={styles.itemCount}>{cartItems.length} ürün</span>
          </div>
          <div style={styles.headerRight}>
            {isMobile && (
              <span style={styles.totalPrice}>
                {prices.totalPrice.toFixed(2)} ₺
              </span>
            )}
            {isMobile && (
              <i
                className={
                  isCollapsed ? "fa fa-chevron-down" : "fa fa-chevron-up"
                }
                style={styles.chevronIcon}
              ></i>
            )}
          </div>
        </div>

        {showContent && (
          <div style={styles.content} className="order-summary-content">
            <hr style={styles.divider} className="order-summary-divider" />

            {/* Ürünler Container - Scrollable (Kozvit tarzı) */}
            <div
              style={styles.itemsContainer}
              className="order-summary-items-container"
            >
              {cartItems.map(function (item, index) {
                const rawImage =
                  (item && item.image) ||
                  (item && item.product && item.product.image) ||
                  null;
                const imageSrc = rawImage
                  ? rawImage.startsWith("http")
                    ? rawImage
                    : PUBLIC_DIR(rawImage)
                  : "/images/no-image.png";

                return (
                  <div key={index} style={styles.productItem}>
                    <div style={styles.productImageWrapper}>
                      <img
                        src={imageSrc}
                        alt={item.name}
                        style={styles.productImage}
                        onError={function (e) {
                          e.target.onerror = null;
                          e.target.src = "/images/no-image.png";
                        }}
                      />
                      <span style={styles.quantityBadge}>{item.quantity}</span>
                    </div>
                    <div style={styles.productInfo}>
                      <div style={styles.productName}>{item.name}</div>
                      <div style={styles.productPrice}>
                        {item.price &&
                        item.sale_price &&
                        item.price !== item.sale_price ? (
                          <span style={styles.productPriceOld}>
                            {(item.price * item.quantity).toFixed(2)} ₺
                          </span>
                        ) : null}
                        {item.sale_price || item.price ? (
                          <span>
                            {(
                              (item.sale_price || item.price) * item.quantity
                            ).toFixed(2)}{" "}
                            ₺
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <hr style={styles.divider} />

            {/* Fiyat Detayları - Her zaman görünür */}
            <div style={styles.priceBreakdown}>
              <div style={styles.priceRow}>
                <span style={styles.priceLabel}>Ara Toplam</span>
                <span style={styles.priceValue}>
                  {prices.cartTotalPrice.toFixed(2)} ₺
                </span>
              </div>

              {/* Kategori indirimleri */}
              {prices.categoryDiscount > 0 && (
                <div style={styles.discountRow}>
                  <span style={styles.discountLabel}>
                    <i className="fa fa-tag" style={styles.discountIcon}></i>
                    Sepette İndirim
                  </span>
                  <span style={styles.discountValue}>
                    -{prices.categoryDiscount.toFixed(2)} ₺
                  </span>
                </div>
              )}

              {/* Premium Müşteri İndirimi */}
              {prices.customerDiscount > 0 && (
                <div style={styles.premiumDiscountRow}>
                  <span style={styles.premiumDiscountLabel}>
                    <i className="fa fa-crown" style={styles.premiumDiscountIcon}></i>
                    Premium Müşteri İndirimi
                  </span>
                  <span style={styles.premiumDiscountValue}>
                    -{prices.customerDiscount.toFixed(2)} ₺
                  </span>
                </div>
              )}

              {/* Kargo */}
              <div style={styles.priceRow}>
                <span style={styles.priceLabel}>Teslimat / Kargo</span>
                <span style={styles.priceValue}>
                  {prices.shippingCost > 0 ? (
                    prices.shippingCost.toFixed(2) + " ₺"
                  ) : (
                    <span style={{ color: "#84b817", fontWeight: "700" }}>
                      Ücretsiz
                    </span>
                  )}
                </span>
              </div>

              {/* Ücretsiz kargo bilgisi */}
              {prices.shippingCost === 0 &&
                prices.freeShippingThreshold > 0 && (
                  <div style={styles.freeShippingInfo}>
                    <i
                      className="fa fa-truck"
                      style={styles.freeShippingIcon}
                    ></i>
                    <span style={styles.freeShippingText}>
                      {prices.freeShippingThreshold.toFixed(2)} TL ve üzeri
                      ücretsiz kargo
                    </span>
                  </div>
                )}
            </div>

            {/* Toplam */}
            <div style={styles.totalSection}>
              <div style={styles.totalRow}>
                <span style={styles.totalLabel}>Toplam</span>
                <span style={styles.totalValue}>
                  {prices.totalPrice.toFixed(2)} ₺
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    color: "#1a1d1f",
    height: "100%",
    paddingTop: "32px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // padding: "16px 24px",
    flexShrink: 0,
    cursor: "pointer",
    userSelect: "none",
    transition: "background-color 0.2s ease",
    // backgroundColor: "#FFF",
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a1d1f",
  },
  itemCount: {
    fontSize: "13px",
    color: "#6f7a8d",
    fontWeight: "500",
  },
  totalPrice: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1a1d1f",
  },
  chevronIcon: {
    fontSize: "14px",
    color: "#6f7a8d",
    transition: "transform 0.2s ease",
  },
  content: {
    padding: "0 24px 24px",
  },
  divider: {
    margin: "16px 0",
    border: 0,
    borderTop: "1px solid #e6eaf2",
    flexShrink: 0,
  },
  itemsContainer: {
    maxHeight: "50vh",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    paddingRight: "8px",
    flexShrink: 0,
    paddingTop: "8px",
  },
  productsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: "1 1 auto",
    minHeight: 0,
    marginBottom: "16px",
  },
  productItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  productImageWrapper: {
    position: "relative",
    flexShrink: 0,
    width: "64px",
    height: "64px",
  },
  productImage: {
    width: "64px",
    height: "64px",
    objectFit: "cover",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#f9fafb",
  },
  quantityBadge: {
    position: "absolute",
    top: "-8px",
    right: "-8px",
    backgroundColor: "#84b817",
    color: "#ffffff",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "600",
    border: "2px solid #ffffff",
    boxShadow: "0 2px 8px rgba(132, 184, 23, 0.3)",
  },
  productInfo: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "64px",
  },
  productName: {
    fontSize: "14px",
    fontWeight: "400",
    color: "#1f2937",
    marginBottom: "4px",
    lineHeight: 1.4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  productPrice: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1f2937",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "flex-end",
  },
  productPriceOld: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#9ca3af",
    textDecoration: "line-through",
  },
  priceBreakdown: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flexShrink: 0,
  },
  priceRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  priceLabel: {
    fontSize: "15px",
    color: "#6f7a8d",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flex: "1",
  },
  priceValue: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1a1d1f",
    textAlign: "right",
  },
  discountRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  discountLabel: {
    fontSize: "13px",
    color: "#ff5c5c",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  discountIcon: {
    fontSize: "12px",
  },
  discountValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#ff5c5c",
  },
  premiumDiscountRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f0f9e8",
    padding: "10px 12px",
    borderRadius: "8px",
    marginTop: "4px",
    marginBottom: "4px",
  },
  premiumDiscountLabel: {
    fontSize: "13px",
    color: "#5a7a14",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  premiumDiscountIcon: {
    fontSize: "12px",
    color: "#84b817",
  },
  premiumDiscountValue: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#5a7a14",
  },
  freeShippingInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 14px",
    backgroundColor: "#f0f9e8",
    borderRadius: "10px",
    marginTop: "4px",
  },
  freeShippingIcon: {
    fontSize: "14px",
    color: "#84b817",
  },
  freeShippingText: {
    fontSize: "13px",
    color: "#5a7a14",
    fontWeight: "500",
    lineHeight: 1.4,
  },
  totalSection: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flexShrink: 0,
    borderTop: "2px solid #e5e7eb",
    paddingTop: "20px",
    marginTop: "20px",
  },
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  totalLabel: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1f2937",
    flex: "1",
  },
  totalValue: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1f2937",
    textAlign: "right",
  },
};

const mapStateToProps = (state) => ({
  cart: state.cart,
  settings: state.setting && state.setting.setting ? state.setting.setting : {},
  customer: state.customer.customer,
});

export default connect(mapStateToProps, {
  incCart,
  decCart,
  updateCartQuantity,
})(OrderSummaryWidget);



// WEBPACK FOOTER //
// ./src/components/OrderSummaryWidget.js